import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { checkPermission } from 'helpers/helpers'

// Kassir "Bo'limlar" menyusi — orqaga strelka shu yerga olib keladi.
// Chap tomonda tik ro'yxat; Kassa eng tepada. Har bo'lim ruxsat galochkasiga bog'langan.
function CashboxMenu() {
	const { t } = useTranslation()
	const navigate = useNavigate()

	/* ⚠️ Ruxsatlarga OBUNA. `checkPermission()` store'ni to'g'ridan-to'g'ri
	   o'qiydi — u qayta chizilishni KELTIRIB CHIQARMAYDI. Kassir maketi
	   sahifa ochilganda ruxsatlarni serverdan yangilaydi (cashier/Layout.js);
	   obunasiz menyu eski ro'yxat bilan chizilib qolar va yangi galochka
	   faqat keyingi o'tishda ko'rinardi. `permissions` o'zgarishi shu yerda
	   qayta chizishni majburlaydi. */
	useSelector(state => state.account?.permissions)

	// Kassa doim birinchi; qolganlari mantiqiy ketma-ketlikda (umumiy -> pul -> qaytarish -> o'chirilgan)
	const sections = [
		{ perm: 'cashbox.rep_dashboard',        path: '/cashbox/asosiy',           i18n: 'home',               icon: 'uil-chart-pie-alt',  color: '#5b2be7' },
		{ perm: 'cashbox.rep_income_expense',   path: '/cashbox/kirim-chiqim',     i18n: 'income_expense',     icon: 'uil-transaction',    color: '#1a73e8' },
		{ perm: 'cashbox.rep_rasxodlar',        path: '/cashbox/rasxodlar',        i18n: 'expenses_by_worker', icon: 'uil-money-withdraw', color: '#0f9d58' },
		{ perm: 'cashbox.rep_returns',          path: '/cashbox/returns',          i18n: 'returns_report',     icon: 'uil-corner-up-left', color: '#b8860b' },
		{ perm: 'cashbox.rep_deleted_cheques',  path: '/cashbox/deleted-cheques',  i18n: 'deleted_cheques',    icon: 'uil-file-times-alt', color: '#d93025' },
		{ perm: 'cashbox.rep_deleted_expenses', path: '/cashbox/deleted-expenses', i18n: 'deleted_expenses',   icon: 'uil-trash-alt',      color: '#d93025' },
		// Xodimlar hisob-kitobi — kassir avans/oylik berganda kimga berganini
		// yozadi va qolgan qarzni ko'radi. Har kassirga kerak emas, shuning
		// uchun galochka bilan yoqiladi (`cashbox.employee_account`).
		// ⚠️ `sec` — TARIF ruxsati (xodim galochkasidan alohida). Backend
		//    ikkalasini ham talab qiladi: `['section:sec.employee_account',
		//    'hr:cashbox.employee_account']` (api.php:277). Ilgari bu yerda
		//    faqat galochka tekshirilardi va tarifi yopiq tenantда kassir
		//    kartani bosib, bo'sh jadval + qizil toast olardi.
		{ perm: 'cashbox.employee_account', sec: 'sec.employee_account', path: '/cashbox/employee-account', i18n: 'employee_account',   icon: 'uil-users-alt',      color: '#7c3aed' },
		// Aksessuar chizmalari — sotuvchi shablon yasashi/tahrirlashi uchun.
		// ⚠️ IKKI shart: xodim galochkasi (`cashbox.accessory_drawings`) VA
		//    biznes tarifi (`sec.accessory_drawing`, Full). Backend ham
		//    ikkalasini talab qiladi (api.php: section + hr middleware),
		//    shuning uchun bittasi yetmasa karta ko'rinmasin — aks holda
		//    kassir bosib, bo'sh sahifa va qizil toast olardi.
		{ perm: 'cashbox.accessory_drawings', sec: 'sec.accessory_drawing', path: '/cashbox/accessory-drawings', i18n: 'accessory_drawings', icon: 'uil-ruler-combined', color: '#0891b2' },
		/* Mijoz shikoyat/takliflari — sotuvchi mijozga javob berishi uchun.
		   ⚠️ IKKI shart (boshqa kartalar bilan bir xil naqsh): xodim galochkasi
		      (`cashbox.complaints`) VA biznes tarifi (`sec.complaints`). Backend
		      ham ikkalasini talab qiladi (api.php: section + hr), shuning uchun
		      bittasi yetmasa karta ko'rinmasin — aks holda sotuvchi bosib,
		      bo'sh sahifa va qizil toast olardi. */
		{ perm: 'cashbox.complaints', sec: 'sec.complaints', path: '/cashbox/complaints', i18n: 'complaints', icon: 'uil-comment-alt-exclamation', color: '#dc2626' },
	]

	const items = [
		{ path: '/cashbox', i18n: 'cashbox', icon: 'uil-receipt-alt', color: '#5b2be7', main: true },
		...sections.filter((s) => checkPermission(s.perm) && (!s.sec || checkPermission(s.sec))),
	]

	// Rangni yumshoq fon (chip) uchun ochiqroq qilamiz
	const tint = (hex) => hex + '1a'

	return (
		<>
			<div className="page-header">
				<h4 className="mb-0">{t('sections')}</h4>
			</div>

			<div className="row">
				<div className="col-xl-4 col-lg-5 col-md-7">
					<div className="d-flex flex-column gap-2">
						{items.map((it, i) => (
							<div key={i} className="card cursor mb-0"
								style={it.main ? { border: '1px solid #d9cffb', background: '#faf8ff' } : {}}
								onClick={() => navigate(it.path)}>
								<div className="card-body d-flex align-items-center gap-3 py-3 px-3">
									<span className="d-flex align-items-center justify-content-center flex-shrink-0"
										style={{ width: 44, height: 44, borderRadius: 10, background: tint(it.color) }}>
										<i className={it.icon} style={{ fontSize: 20, color: it.color }}></i>
									</span>
									<span className="fw-600" style={{ fontSize: 15 }}>{t(it.i18n)}</span>
									<i className="uil-angle-right ms-auto text-muted" style={{ fontSize: 20 }}></i>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</>
	)
}

export default CashboxMenu
